import React from 'react';

const ProductCard = ({ product, onAddToCart, onProductClick }) => {
  return (
    <div
      className="bg-white rounded-xl p-4 flex flex-col text-center cursor-pointer transition-transform transform hover:scale-105 h-full"
      onClick={() => onProductClick(product.id)}
    >
      {/* Imagen centrada */}
      <div className="w-full aspect-square flex items-center justify-center mb-4 bg-white">
        <img
          src={product.image}
          alt={product.name}
          className="max-w-full max-h-full object-contain rounded-lg"
        />
      </div>

      {/* Contenido */}
      <div className="flex flex-col flex-grow justify-between">
        <h3 className="text-lg font-semibold text-gray-800 mb-2 min-h-[3.5rem] leading-snug">
          {product.name}
        </h3>

        <p className="text-gray-900 text-xl font-bold mb-4">
          ₡{product.price.toLocaleString('es-CR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </p>

        <button
          onClick={(e) => {
            e.stopPropagation(); // Evita navegación al hacer clic
            onAddToCart({ ...product, quantity: 1 }); // Asegura que tenga cantidad
          }}
          className="w-full bg-[#5A61E5] text-white py-2 rounded-lg hover:bg-[#4A51D5] transition-colors duration-300 text-sm font-medium mt-auto"
        >
          Agregar al Carrito
        </button>
      </div>
    </div>
  );
};

export default ProductCard;
